<template>
  <base-modal
    :reference="'addStopSchedule_' + item.id"
    :title="title"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
    :size="'lg'"
  >
    <template v-slot:body v-if="show && item !== 'undefined' && activity_group !== 'undefined'">
        <div>
            <p class="alert-info rounded-sm w-57 mx-auto font-weight-bold py-2">
                Añadir <strong style="text-decoration: underline;">{{item.name}}</strong> <span style="font-size: 0.8rem;">({{item.sub_zone.name}} - {{item.sub_zone.pickup_zone.name}} - {{item.sub_zone.pickup_zone.supra_zone.name}})</span> 
                como parada en el grupo <span style="text-decoration: underline;">{{activity_group.name}}</span>
            </p>
            <p v-if="transformStops.length == 0" class="text-info">
                <i class="fa fa-info-circle mr-2"></i>
                <span>
                    {{item.name}} se colocará como la primera parada en {{item.sub_zone.pickup_zone.name}}
                </span>
            </p>
        </div>
        <form>
            <div v-if="transformStops.length > 0" class="d-flex my-4 w-100">
                <div class="d-flex flex-row align-items-sm-baseline text-left">
                    <label for="" class="mr-2">Añadir</label> 
                    <v-select
                        :options="addPositionOptions"
                        :reduce="(option) => option.id"
                        label="label"
                        v-model="form.insert_at"
                        style="width: 9vw"
                    >

                    </v-select>

                    <label for="" class="mx-2">de la parada</label>
                    <v-select
                        :options="transformStops"
                        @search="onSearchStops"
                        :reduce="(option) => option.id"
                        label="name"
                        v-model="form.stop_id"
                        style="width: 17vw"
                    >
                    </v-select>
                </div>
            </div>

            
            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>Hora de paso</label>
                    <b-form-input
                        type="time"
                        v-model="form.hour"
                        placeholder="Inserte hora de paso"
                        style="width: 17vw"
                    ></b-form-input>
                </div>
            </div>
            
            <div v-if="showErrorAfterBefore && transformStops.length > 0">
                <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                    Debe especificar la parada de referencia donde insertar la nueva
                </p>
            </div>
            <div v-if="showErrorHour">
                <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                    Debe especificar la hora de pasada por la nueva parada
                </p>
            </div>
        </form>
    </template>
    
  </base-modal>
</template>

<script>
/* eslint-disable */

import BaseModal from "../../Excursions/Booking/Modal/BaseModal";

export default {
  components: {
    BaseModal,
  },
  props: {
    item: {
      type: Object || null,
      required: false,
    },
    activity_group: {
        type: Object || undefined ,
        required: false,
    },
    stops: {
        type: Array,
        required: true
    }
  },
  data() {
    return {
        show: false,
        submitAllowed: false,
        addPositionOptions: [
            {
                id: 1,
                label: 'Antes'
            },
            {
                id: 2,
                label: 'Después'
            },
            {
                id: 3,
                label: 'Primera'
            },
            {
                id: 4,
                label: 'Última'
            }
        ],
        form: {
            hour: '',
            stop_id: null,
            insert_at: 1,
            activity_group_id: this.activity_group != null ? this.activity_group.id : null,
            geo_point_id: this.item != null ? this.item.id : null,
        },
    };
  },
  async mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      const current = "addStopSchedule_" + this.item.id;
      if (modalId == current) {
        this.show = true
        this.form.geo_point_id = this.item.id // force setting geo point id when modal is opened
        this.form.stop_id = null
        // get data
      }
    });
  },
  beforeDestroy() {
  },
  methods: {
    async acceptAction() {
        if ( this.showErrorAfterBefore || this.showErrorHour ) {
            return
        }
        
        this.form.activity_group_id = this.activity_group.id
        let data = {
            payload: {...this.form}
        }
        // dispatch request to backend
        await this.$store.dispatch("stops/createStopScheduleAtPosition", data) 
        // update table of points assigned to stops
        data = {
                'activity_group_id': this.activity_group.id,
            }
        await this.$store.dispatch("stops/loadStopsAdmin", data)
        // update table of points not yet assigned to stops
        data = {
            'activity_group_id': this.activity_group.id,
            'suprazone_id': this.activity_group.suprazone_id,
        }
        await this.$store.dispatch("geopoints/geoPointNotStopSchedule", data)
        this.$bvModal.hide("addStopSchedule_" + this.item.id);
        this.$notify({
            group: "foo",
            title: "Parada configurada",
            text: "Se ha creado una parada a partir del punto geográfico",
            type: "success",
        });
    },
    async onSearchStops(search, loading) {
      
    },
  },
  computed: {
        transformStops() {
            // filter stops that belongs to the same subzone than the provided point
            let filteredStops = this.stops.filter(
                entry => entry.geo_point.sub_zone.pickup_zone.id == this.item.sub_zone.pickup_zone.id
            )
            let out = []
            for (let i in filteredStops) {
                out.push(
                    {
                        id: filteredStops[i].id,
                        name: filteredStops[i].geo_point.name
                    }
                )
            }
            return out
        },
        group_name() {
            return this.activity_group != null ? this.activity_group.name : ''
        },
        title() {
            return `Establecer nueva parada en el grupo ${this.group_name}`
        },
        showErrorAfterBefore() {
            if (( this.form.insert_at == 1 || this.form.insert_at == 2 ) && this.form.stop_id == null && this.transformStops.length > 0 ) {
                return true
            }
            return false
        },
        showErrorHour() {
            if ( this.form.hour == '' ) {
                return true
            }
            return false
        }
  },
    watch: {
        item: function() {
        }
    }
};
</script>